<template>
    <div class="cabinet-content-wrap">
        <header class="cabinet-header flex flex-align-center">
            <h1 class="h1 cabinet-title">
                Заказы
            </h1>
        </header>

        <order-list />
    </div>
</template>

<script>
import OrderList from '@/components/Cabinet/Supplier/Orders/OrderList'

export default {
    name: 'SupplierOrders',
    components: {
        OrderList
    }
}
</script>
